export default __webpack_public_path__ + "static/media/rnd02_1.1bd17a36.png";